import apiFetch from '../apiFetch'

export default function (token, body, brandId) {
  const formData = new FormData()
  for (var key in body) {
    formData.append(key, body[key])
  }
  return apiFetch({ endPoint: `Vehicle/ImportVehicleModels?brandId=${brandId}`, method: 'POST', body: formData, fileBody: true, token: token })
}
